import { render } from "./IconInstagram.vue?vue&type=template&id=02f4bc92"
import script from "./IconInstagram.vue?vue&type=script&lang=js"
export * from "./IconInstagram.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__